export const environment = {
  name: 'test',
  apiUrl: 'https://betaalverzoek-api.testing.knab.nl/api',
  shouldTrimPublicId: true,
  launchMobileConsole: true,
  otlpTracesUrl: 'https://betaalverzoek-api.testing.knab.nl/otlp/v1/traces',
  otlpMetricsUrl: 'https://betaalverzoek-api.testing.knab.nl/otlp/v1/metrics',
  otlpLogsUrl: 'https://betaalverzoek-api.testing.knab.nl/otlp/v1/logs'
};
